import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Tooltip } from '../Tooltip';
import { getIconConfig } from './helpers';
import { FilledIcon, OutlineIcon, IconWrapper } from './styled';
export const InfoTooltipIcon = memo(function InfoTooltipIcon({ tooltip, placement = 'top', size = 16, type = 'info', dataTestId, dataTestIdIcon, }) {
    const { colors } = useTheme();
    const iconConfig = useMemo(() => getIconConfig(type, colors), [type, colors]);
    if (!iconConfig)
        return null;
    const { Icon, color } = iconConfig;
    return (_jsx(Tooltip, { placement: placement, tooltip: tooltip, dataTestId: dataTestId, children: _jsxs(IconWrapper, { "data-testid": dataTestIdIcon, children: [_jsx(OutlineIcon, { children: _jsx(Icon, { size: size, color: color, dataTestId: 'outlined' }) }), _jsx(FilledIcon, { children: _jsx(Icon, { size: size, color: color, filled: true, dataTestId: 'filled' }) })] }) }));
});
